export class Fitness {
    hr_max: number;
    hr_rest: number;
    bp_coef_numerator: number;
    bp_coef_denumerator: number;
    respiration_coef: number;
    weight: number;
    height: number;
}
